import { Box, Tab, Tabs } from '@mui/material';
import { CashTypeEnum } from '../../../enums/cashType';
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../constants/colors';

interface Props {
    value: CashTypeEnum;
    onChange: (newValue: CashTypeEnum) => void;
}

const TabOrderCashTypeComponents = ({ value, onChange }: Props) => {
    return (
        <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR }}>
            <Box sx={{ borderBottom: 'none', borderColor: 'divider' }}>
                <Tabs value={value} onChange={(e: any, newValue: CashTypeEnum) => {
                    onChange(newValue)
                }} variant="scrollable" scrollButtons="auto">
                    <Tab label="Cash" value={CashTypeEnum.CASH} sx={{ textTransform: 'none' }} />
                    <Tab label="OnePay" value={CashTypeEnum.ONE_PAY} sx={{ textTransform: 'none' }} />
                    <Tab label="Return" value={CashTypeEnum.RETURN} sx={{ textTransform: 'none' }} />
                </Tabs>
            </Box>
        </Box>
    );
};
export default TabOrderCashTypeComponents;
